import React, { ReactNode } from "react";
import { Outlet } from "react-router";

class ErrorFestBoundary extends React.Component<{ children: ReactNode }, { hasError: boolean; error: any }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, errorInfo: unknown) {
    // generic catch-all location for all errors that occur in the app.
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          {/*<div style={{ color: "red", padding: "10px" }}>An error occurred: {this.state.error.message}</div>*/}
          <Outlet />
        </>
      );
    }

    return <Outlet />;
  }
}

export default ErrorFestBoundary;
